import EntityPageFindAndReplace from "containers/entity/page/EntityPageFindAndReplace";
import EntityPageList from "containers/entity/page/EntityPageList";
import React, { useState, useEffect } from "react";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { get } from "aws-amplify/api";
import "react-datepicker/dist/react-datepicker.css";
import "containers/common/List.css";
import "containers/common/Table.css";
import "containers/entity/page/EntityPageSearch.css";
import { createElementIdFactory } from "utils/elementIds";

function EntityPageSearch({
    isAuthenticated,
    user,
}) {
    const createId = createElementIdFactory("entity-search-form");

    const [entities, setEntities] = useState('');
    const [formData, setFormData] = useState({
        selectedCityscope: [],
        property_key: "",
        state: "",
        name: "",
        contactname: "",
        acn: "",
        selectedIsCompanyOption: { label: "Companies & Individuals", value: null }
    });
    const [stateFilter, setStateFilter] = useState({
        state: "",
        name: "",
        contactname: ""
    });
    const [isLoading, setIsLoading] = useState(true);
    const [showEntityFindAndReplace, setShowEntityFindAndReplace] = useState(false);

    // --- Data Fetching and Update Functions ---
    useEffect(() => {
        if (!isAuthenticated) return;

        document.title = "Cityscope Entity Search";
        (async () => {
            setIsLoading(true);

            const results = await getEntities(stateFilter);
            setEntities(results);
            setIsLoading(false);
        })();
    }, [isAuthenticated, stateFilter]);

    // --- Data Fetching ---
    async function getEntities(filter) {
        const queryParams = {
            state: filter?.state ?? "",
            name: filter?.name ?? "",
            contactname: filter?.contactname ?? ""
        };
        const options = {
            queryParams,
        };
        const response = await get({
            apiName: "colin",
            path: "/entities",
            options,
        }).response;
        try {
            const ent = await response.body.json();
            return ent;
        } catch (error) {
            alert(error + ". Please refresh the page (F5) to try again.");
        }
    }

    // --- Handlers ---
    const handleLocalInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    async function handleSubmit(event) {
        event.preventDefault();
        setIsLoading(true);

        setStateFilter({
            state: formData.state ?? "",
            name: formData.name ?? "",
            contactname: formData.contactname ?? ""
        });
    }

    function handleEnityFindAndReplace(event) {
        setShowEntityFindAndReplace(!showEntityFindAndReplace);
    }

    // --- Render Functions ---
    function renderEntityPageSearch() {
        return (
            <div id={createId("page")}>
                <div>
                    {showEntityFindAndReplace &&
                        <Modal show={showEntityFindAndReplace} onHide={handleEnityFindAndReplace} dialogClassName="entity-search-modal-90w">
                            <Modal.Header closeButton>
                                <Modal.Title>Find &amp; Replace Entity</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <EntityPageFindAndReplace
                                    isAuthenticated={isAuthenticated}
                                    user={user}
                                    onClose={handleEnityFindAndReplace}
                                />
                            </Modal.Body>
                        </Modal>}
                </div>
                <Container fluid id={createId("container")}>
                    <Row >
                        <Col sm={12} md={12} lg={12}>
                            <h6>
                                Cityscope Entity Search
                            </h6>
                        </Col>
                    </Row>
                    <Form onSubmit={handleSubmit}>
                        <Row >
                            <Col lg={2}>
                                <Form.Group controlId={createId("state")}>
                                    <Form.Control
                                        name="state"
                                        value={formData.state}
                                        onChange={handleLocalInputChange}
                                        type="input"
                                        placeholder="State"
                                    />
                                </Form.Group>
                            </Col>
                            <Col lg={2}>
                                <Form.Group controlId={createId("name")}>
                                    <Form.Control
                                        name="name"
                                        type="input"
                                        value={formData.name}
                                        onChange={handleLocalInputChange}
                                        placeholder="Entity Name/Entity Code containing" />
                                </Form.Group>
                            </Col>
                            <Col lg={2}>
                                <Form.Group controlId={createId("contactname")}>
                                    <Form.Control
                                        name="contactname"
                                        type="input"
                                        value={formData.contactname}
                                        onChange={handleLocalInputChange}
                                        placeholder="Entity Contact Name containing" />
                                </Form.Group>
                            </Col>
                            <Col lg={2}>
                                <Button type="submit" disabled={isLoading} id={createId("search", "button")}>
                                    Search
                                </Button>
                            </Col>
                            <Col>
                                <Button type="button" onClick={handleEnityFindAndReplace} id={createId("find-replace", "button")}>Entity Find &amp; Replace</Button>
                            </Col>
                        </Row>
                    </Form>

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                            <EntityPageList
                                data={entities || []}
                                isLoading={isLoading}
                                isAuthenticated={isAuthenticated}
                                controlType="table"
                            />
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
    return (
        <div className="EntityPageSearch" id={createId("root")}>
            {isAuthenticated
                ? renderEntityPageSearch()
                : (isAuthenticated ? <p>Loading permissions...</p> : null)}
        </div>
    );
}

export default EntityPageSearch;